// Adapted code from:
// https://github.com/zloirock/core-js/blob/master/packages/core-js/modules/es.uint8-array.to-base64.js
// https://github.com/zloirock/core-js/blob/master/LICENSE -- MIT License

// Since we don't want to edit the core-js code too much, we disable some eslint rules here.
/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/naming-convention */

const commonAlphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const base64Alphabet = `${commonAlphabet}+/`;
const base64UrlAlphabet = `${commonAlphabet}-_`;

// `toBase64` is a recent addition to `Uint8Array` that is not available in all
// runtimes we support, so we describe it as an optional method (rather than
// extending `Uint8Array`, whose lib typings now declare it as always present)
// to keep the runtime feature-detection below meaningful.

// Opposite of core-js INCORRECT_BEHAVIOR_OR_DOESNT_EXISTS, with adapted checks.
// core-js checks for `null` argument, which throws in Firefox.
// But our function definition only allows `undefined`, so we check for `undefined` instead.
const toBase64Working = !!Uint8Array.prototype.toBase64 && (() => {
  try {
    const a = new Uint8Array();
    const b = new Uint8Array([29, 233, 101, 161]);
    const c = new Uint8Array([126, 126, 126, 255, 254]);
    return a.toBase64?.() === "" && b.toBase64?.({}) === "HelloQ==" && b.toBase64?.({
      omitPadding: true
    }) === "HelloQ" && c.toBase64?.({
      alphabet: "base64url",
      omitPadding: true
    }) === "fn5-__4";
  } catch {
    return false;
  }
})();

/**
 * Polyfill for Uint8Array.toBase64() method.
 * Calls Uint8Array.toBase64() if available and working, otherwise uses the core-js implementation.
 * @param array
 * @param options
 * @returns
 */
export function uint8ArrayToBase64(array, options) {
  // Use built-in Uint8Array.toBase64() if available, otherwise use a polyfill.
  const arrayExt = array;
  if (arrayExt.toBase64 && toBase64Working) {
    return arrayExt.toBase64(options);
  }

  // Don't be tempted to use this, since it will fail with "call stack size exceeded" for large arrays > 100,000 bytes:
  // return btoa(String.fromCharCode(...array)); // NOT WORKING FOR LARGE ARRAYS

  // Adapted core-js implementation:
  const alphabet = options?.alphabet === "base64url" ? base64UrlAlphabet : base64Alphabet;
  const omitPadding = !!options?.omitPadding;
  let result = "";
  let i = 0;
  const length = array.length;
  let triplet;
  function at(shift) {
    return alphabet.charAt(triplet >> 6 * shift & 63);
  }
  for (; i + 2 < length; i += 3) {
    triplet = (array[i] << 16) + (array[i + 1] << 8) + array[i + 2];
    result += at(3) + at(2) + at(1) + at(0);
  }
  if (i + 2 === length) {
    triplet = (array[i] << 16) + (array[i + 1] << 8);
    result += at(3) + at(2) + at(1) + (omitPadding ? "" : "=");
  } else if (i + 1 === length) {
    triplet = array[i] << 16;
    result += at(3) + at(2) + (omitPadding ? "" : "==");
  }
  return result;
}